module.exports = function() {
  return new Worker(__webpack_public_path__ + "a4e6781ba222353253bf.worker.js");
};